import { render } from "./RelationshipTypeDetails.vue?vue&type=template&id=4af16cbe"
import script from "./RelationshipTypeDetails.vue?vue&type=script&lang=js"
export * from "./RelationshipTypeDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__